module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-58-min.43770f05.jpg";